angular.module("app").factory("pagination", [
    "settingsService",
    "$rootScope",
    function (settingsService, $rootScope) {

        var pagination = {
            page: 1,
            changePage: angular.noop,
            totalItems: 0,
            limit: 25,
            maxSize: 5
        };
        return {
            init: function (changePage, totalItems, limit, pageId, notUseEnv, limits) {
                var temp = angular.copy(pagination),
                    filtersData = settingsService.getFilters();
                if (!!changePage) {
                    temp.changePage = changePage
                }
                if (!!totalItems) {
                    temp.totalItems = totalItems
                }
                if (!!limit) {
                    temp.limit = limit
                }
                if (angular.isDefined(filtersData.current_page)) {
                    temp.page = filtersData.current_page
                }
                if (angular.isDefined(filtersData.limit)  && limit === undefined) {
                    temp.limit = filtersData.limit
                }
                if ($rootScope.env && !notUseEnv) {
                    if ($rootScope.env.pagination && !pageId) {
                        temp.limit = $rootScope.env.pagination.limit;
                        temp.page = $rootScope.env.pagination.current_page;
                    }else if (pageId && $rootScope.env['pagination' + pageId]) {
                        temp.limit =$rootScope.env['pagination' + pageId].limit;
                        temp.page = $rootScope.env['pagination' + pageId].current_page;
                    }
                }

                if (limits) {
                    temp.limits = limits;
                } else {
                    temp.limits = [ {value: 5}, {value: 10}, {value: 25}, {value: 50}];
                }
                return temp
            }
        }
    }
]);
